"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTestimonialsState = void 0;
exports.defaultTestimonialsState = {
    showRating: true,
    caption: '652 Total Reviews with an Average Rating of 4.5 / 5.0',
    nameViewAll: 'View all reviews',
    items: [
        {
            name: 'Sayaka',
            title: 'Consultant',
            image: 'https://images.okay.com/AgentThumbnail/Source/581_636663148845061393.jpg',
            fullText: 'We can confidently recommend Sayaka as an excellent property agent, who was extremely polite, professional, sympathetic and very understanding. We are extremely pleased with the service provided by Sayaka even we had very limited time, she was always resourceful with updated market situation for our flat hunting(letting). We will be recommending her to friends and family. And definitely we will back to her for our near future flat hunting! ',
            quoteFrom: 'Roy Cheung',
            rate: 4.1,
        },
        {
            name: 'Sayaka',
            title: 'Consultant',
            image: 'https://images.okay.com/AgentThumbnail/Source/581_636663148845061393.jpg',
            fullText: 'We can confidently recommend Sayaka as an excellent property agent, who was extremely polite, professional, sympathetic and very understanding. We are extremely pleased with the service provided by Sayaka even we had very limited time, she was always resourceful with updated market situation for our flat hunting(letting). We will be recommending her to friends and family. And definitely we will back to her for our near future flat hunting! ',
            quoteFrom: 'Roy Cheung',
            rate: 4.9,
        },
        {
            name: 'Sayaka',
            title: 'Consultant',
            image: 'https://images.okay.com/AgentThumbnail/Source/581_636663148845061393.jpg',
            fullText: 'We can confidently recommend Sayaka as an excellent property agent, who was extremely polite, professional, sympathetic and very understanding. We are extremely pleased with the service provided by Sayaka even we had very limited time, she was always resourceful with updated market situation for our flat hunting(letting). We will be recommending her to friends and family. And definitely we will back to her for our near future flat hunting! ',
            quoteFrom: 'Roy Cheung',
            rate: 4.5,
        },
    ],
};
